var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","float":"left","text-align":"center","font-size":"30px"}},[_c('CSpinner',{attrs:{"color":"success","size":"sm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }